
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InfoIcon from '@mui/icons-material/Info';
import { general } from '../../config.json'
import { useEffect, useState } from 'react';

import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import { styled, useTheme } from '@mui/material/styles';
import { useConfig } from '../../Services/useConfig';


const DrawerHeader = styled('div')(({ theme }) => ({

    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
}));


export default function LeftSubDrawerMobile(props: any) {
    const config = useConfig()
    
    return (
        <Drawer
            //todo: move to own component
            transitionDuration={0}
            sx={{
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: config.general["leftDrawerWidthMobile"],
                    // boxSizing: "border-box",
                },
            }}
            BackdropProps = {{
                invisible:true,
            }}
            onClose={() => props.setLeftSubDrawerOpen(false)}
            // variant="permanent"
            anchor="left"
            open={props.leftSubDrawerOpen}
        >
            <DrawerHeader>
                <AppBar
                    sx={{
                        width: config.general["leftDrawerWidthMobile"],
                        ml: 0,
                        mr: `calc(100% - ${config.general["leftDrawerWidthMobile"]})`
                    }}>
                    <Toolbar>
                        <Box display='flex' flexGrow={1}>
                            <Typography variant="h6" component="div">
                                {props.title}
                            </Typography>
                        </Box>
                        {props.title === "Waldzustand" && <SelectYear version={props.version} setVersion={props.setVersion} />}
                        <IconButton edge="end" color="inherit" aria-label="open drawer" onClick={() => props.setLeftSubDrawerOpen(!props.leftSubDrawerOpen)} >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
            </DrawerHeader>
            <Box sx={{ overflow: "auto" }}>
            {props.children}
            </Box>
        </Drawer>

    );
}
function SelectYear({version, setVersion}: any) {

    const handleChange = (event: SelectChangeEvent) => {
        setVersion(event.target.value as string);
    };

    return (
        <FormControl size="small" sx={{ width: 135, mr:2}}>
            <InputLabel id="demo-simple-select-label">Zeitraum</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={version}
                label="Zeitraum"
                onChange={handleChange}
            >
                <MenuItem value="2016_2020">2016 - 2020</MenuItem>
                <MenuItem value="2020_2021">2020 - 2021</MenuItem>
                <MenuItem value="2021_2022">2021 - 2022</MenuItem>
                <MenuItem value="2022_2023">2022 - 2023</MenuItem>
            </Select>
        </FormControl>

    );
}